import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const ClinicSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titleHospital
      }
    >
      <SectionRow>
        <TextInputWithLabel
          elementName="clinic_name"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalName
          }
        />
        <TextInputWithLabel
          elementName="clinic_ik_number"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalIkNumber
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="clinic_location_street"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalStreet
          }
        />
        <TextInputWithLabel
          elementName="clinic_location_street_number"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalStreetNumber
          }
        />
        <TextInputWithLabel
          elementName="clinic_location_zipcode"
          isBold
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalZipCode
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          elementName="clinic_location_city"
          isBold
          isLarge
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .hospitalCity
          }
        />
      </SectionRow>
    </Section>
  );
};
